export default "__VITE_ASSET__Co72KItS__"